import { render, staticRenderFns } from "./WorkshopStats.vue?vue&type=template&id=384cd75e&"
import script from "./WorkshopStats.vue?vue&type=script&lang=js&"
export * from "./WorkshopStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports